import { connect } from 'react-redux';
import { openModal } from '../../../../../modules/modals/store/modal.actions';
import { MODAL_ID } from '../../../../../common/constants/modal/ids.modal.constants';
import { ClientSeedInput } from './clientSeedInput';

const mapStateToProps = (state) => {
	return {
		value: state.seed && state.seed.client,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onClick: () =>
			dispatch(
				openModal(MODAL_ID.CHANGE_CLIENT_SEED, 'clientSeedInput.container'),
			),
	};
};

const ClientSeedInputContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
)(ClientSeedInput);

export { ClientSeedInputContainer };
